import MatchVideoRepository from '@/repositories/Api/MatchVideoRepository'
import ProfileRepository from './Api/ProfileRepository'
import CurrencyRepository from './Api/CurrencyRepository'
import UserRepository from './Api/UserRepository'
import RoleRepository from './Api/RoleRepository'
import PermissionRepository from './Api/PermissionRepository'
import CompanyRepository from './Api/CompanyRepository'
import SeniorRepository from './Api/SeniorRepository'
import MasterRepository from './Api/MasterRepository'
import AgentRepository from './Api/AgentRepository'
import PlayerRepository from './Api/PlayerRepository'
import AccountRepository from './Api/AccountRepository'
import TransactionRepository from './Api/TransactionRepository'
import BalanceReportRepository from './Api/BalanceReportRepository'
import DashboardRepository from './Api/DashboardRepository'
import BetSettingRepository from './Api/BetSettingRepository'
import WithdrawRequestRepository from './Api/WithdrawRequestRepository'
import DepositRequestRepository from './Api/DepositRequestRepository'
import DepositSettingRepository from './Api/DepositSettingRepository'
import FightSetupRepository from './Api/FightSetupRepository'
import ParleySetupRepository from './Api/ParleySetupRepository'
import BetHistoryRepository from './Api/BetHistoryRepository'
import ParleyReportRepository from './Api/ParleyReportRepository'
import DomainRepository from './Api/DomainRepository'
import BaccaratBalanceReportRepository from './Api/BaccaratBalanceReportRepository'
import BalanceReportByTypeRepository from './Api/BalanceReportByTypeRepository'
import ChannelRepository from './Api/ChannelRepository'
import ChannelBaccarateRepository from './Api/ChannelBaccarateRepository'
import ChannelCockRepository from './Api/ChannelCockRepository'
import BaccaratResultRepository from './Api/BaccaratResultRepository'
import MemberRepository from './Api/MemberRepository'
import BetTransactionRepository from './Api/BetTransactionRepository'
import SlotBalanceReportRepository from './Api/SlotBalanceReportRepository'
import FightBetHistoryRepository from './Api/FightBetHistoryRepository'
import FightBetHistoryInternalRepository from './Api/FightBetHistoryInternalRepository'
import AssistantRepository from './Api/AssistantRepository'
import PromotionHistoryRepository from './Api/PromotionHistoryRepository'
import RewardRepository from './Api/RewardRepository'
import PointRuleRepository from './Api/PointRuleRepository'
import ClaimRewardHistoryRepository from './Api/ClaimRewardHistoryRepository'
import JackpotHistoryRepository from './Api/JackpotHistoryRepository'
import PaybackCommissionReportRepository from './Api/PaybackCommissionReportRepository'
import PaybackCommissionHistoryReportRepository from './Api/PaybackCommissionHistoryReportRepository'
import BankRepository from './Api/BankRepository'
import AssistantVipRepository from './Api/AssistantVipRepository'
import JackpotSettingRepository from './Api/JackpotSettingRepository'
import BalanceReportVvipRepository from './Api/vvipReport/BalanceReportVvipRepository'
import BalanceReportVvipByTypeRepository from './Api/vvipReport/BalanceReportVvipByTypeRepository'
import BalanceReportVvipByChannelRepository from './Api/vvipReport/BalanceReportVvipByChannelRepository'
import BalanceReportVvipJokerRepository from './Api/vvipReport/BalanceReportVvipJokerRepository'
import PaybackCommissionVvipReportRepository from './Api/vvipReport/PaybackCommissionVvipReportRepository'
import ParleyVvipReportRepository from './Api/vvipReport/ParleyVvipReportRepository'
import AssistantVvipRepository from './Api/AssistantVvipRepository'

const repositories = {
  dashboard: DashboardRepository,
  profile: ProfileRepository,
  currency: CurrencyRepository,
  user: UserRepository,
  role: RoleRepository,
  permission: PermissionRepository,
  company: CompanyRepository,
  senior: SeniorRepository,
  master: MasterRepository,
  agent: AgentRepository,
  player: PlayerRepository,
  account: AccountRepository,
  transaction: TransactionRepository,
  balanceReport: BalanceReportRepository,
  betSetting: BetSettingRepository,
  withdrawRequest: WithdrawRequestRepository,
  depositRequest: DepositRequestRepository,
  depositSetting: DepositSettingRepository,
  fightSetup: FightSetupRepository,
  parleySetup: ParleySetupRepository,
  betHistory: BetHistoryRepository,
  parleyReport: ParleyReportRepository,
  domain: DomainRepository,
  channel: ChannelRepository,
  channelBaccarate: ChannelBaccarateRepository,
  channelCock: ChannelCockRepository,
  baccaratBalanceReport: BaccaratBalanceReportRepository,
  baccaratResult: BaccaratResultRepository,
  member: MemberRepository,
  betTransaction: BetTransactionRepository,
  slotBalanceReport: SlotBalanceReportRepository,
  fightBetHistory: FightBetHistoryRepository,
  fightBetHistoryInternal: FightBetHistoryInternalRepository,
  assistant: AssistantRepository,
  promotionHistory: PromotionHistoryRepository,
  reward: RewardRepository,
  pointRule: PointRuleRepository,
  claimRewardHistory: ClaimRewardHistoryRepository,
  balanceReportByType: BalanceReportByTypeRepository,
  jackpotHistory: JackpotHistoryRepository,
  paybackCommissionReport: PaybackCommissionReportRepository,
  paybackCommissionHistoryReport: PaybackCommissionHistoryReportRepository,
  bank: BankRepository,
  matchVideo: MatchVideoRepository,
  assistantVip: AssistantVipRepository,
  jackpotSetting: JackpotSettingRepository,
  balanceReportVvip: BalanceReportVvipRepository,
  balanceReportVvipByType: BalanceReportVvipByTypeRepository,
  balanceReportVvipByChannel: BalanceReportVvipByChannelRepository,
  balanceReportVvipJoker: BalanceReportVvipJokerRepository,
  paybackCommissionVvipReport: PaybackCommissionVvipReportRepository,
  parleyVvipReport: ParleyVvipReportRepository,
  assistantVvip: AssistantVvipRepository,
}

export default {
  get: name => repositories[name],
}
